import { render, staticRenderFns } from "./message-pushed.vue?vue&type=template&id=28cb5bac&"
import script from "./message-pushed.vue?vue&type=script&lang=js&"
export * from "./message-pushed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\公司文件\\web\\uni-platform\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('28cb5bac')) {
      api.createRecord('28cb5bac', component.options)
    } else {
      api.reload('28cb5bac', component.options)
    }
    module.hot.accept("./message-pushed.vue?vue&type=template&id=28cb5bac&", function () {
      api.rerender('28cb5bac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/router/views/marketing-manage/message-pushed/message-pushed.vue"
export default component.exports